import { html } from 'lit';
import { ChevronsLeft } from 'lucide-static';
import { unsafeHTML } from 'lit/directives/unsafe-html.js';
import { state } from 'lit/decorators.js';
import { pdsCustomIconElement as customElement } from '../../../decorators/pds-icon';
import { PdsIcon } from '../PdsIcon';

@customElement('pds-icon-chevrons-left')
export class PdsIconChevronsLeft extends PdsIcon {
  @state()
  icon = ChevronsLeft;

  render() {
    return html`${unsafeHTML(this.setIconAttributes())}`;
  }
}
